import { ChainId } from '@1inch-community/models';
import { arbitrum, aurora, avalanche, bsc, fantom, gnosis, klaytn, mainnet, optimism, polygon, zkSync, } from 'viem/chains';
const viemChainId = {
    [ChainId.eth]: mainnet,
    [ChainId.bnb]: bsc,
    [ChainId.matic]: polygon,
    [ChainId.op]: optimism,
    [ChainId.arbitrum]: arbitrum,
    [ChainId.gnosis]: gnosis,
    [ChainId.avalanche]: avalanche,
    [ChainId.fantom]: fantom,
    [ChainId.aurora]: aurora,
    [ChainId.klaytn]: klaytn,
    [ChainId.zkSyncEra]: zkSync,
};
export function getChainById(chainId) {
    return viemChainId[chainId];
}
//# sourceMappingURL=viem-chain-map.js.map